import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-basket-light",
  "use": "icon-basket-light-usage",
  "viewBox": "0 0 19.3 20.3",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 19.3 20.3\" id=\"icon-basket-light\"><path d=\"M17 20.3H2.5L0 5.3h6.2v2H2.4l1.8 11h11.1l1.7-11h-4v-2h6.4l-2.4 15zM8.9 8L7.4 6.7 13.2 0l1.5 1.3L8.9 8z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol